// Auto-generated - do not edit manually
const videoFiles = [
  "Viajando por Brasil.mp4",
  "Viajando por Egipto.mp4",
  "Viajando por Rep Dominicana.mp4",
  "Viajando por Rivera Maya.mp4"
];

const videos = videoFiles.map(filename => ({
  src: `/images/${filename}`,
  title: filename.replace(/\.(mp4|webm|ogg|mov|m4v|avi)$/i, '').replace(/([A-Z])/g, ' $1').trim()
}));

export default videos;
